// Réutilise fetch configuré par lib/http.js : session HttpOnly + jeton CSRF.
const BASE = `${process.env.REACT_APP_BACKEND_URL ?? ''}/api/export`;
export const urlExport = (path) => `${BASE}${path}`;
function detailMessage(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => `${(d.loc || []).join(' › ')} : ${d.msg}`).join('\n');
  if (detail?.message) return `${detail.message}\n${(detail.alertes || []).filter((a) => a.niveau === 'bloquant').map((a) => a.message).join('\n')}`;
  return 'La demande a échoué.';
}
export async function exportApi(path, { method = 'GET', body, signal } = {}) {
  const options = { method, signal };
  if (body instanceof FormData) options.body = body;
  else if (body !== undefined) { options.headers = { 'Content-Type': 'application/json' }; options.body = JSON.stringify(body); }
  const r = await fetch(urlExport(path), options);
  const data = await r.json().catch(() => ({}));
  if (!r.ok) { const error = new Error(detailMessage(data.detail)); error.status = r.status; throw error; }
  return data;
}
export async function telechargerExport(path, nom) {
  const r = await fetch(urlExport(path));
  if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(detailMessage(d.detail)); }
  const objectUrl = URL.createObjectURL(await r.blob());
  const a = document.createElement('a'); a.href = objectUrl; a.download = nom; a.click();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
